import { Component, HostListener, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { delay, of } from 'rxjs';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html'
})

export class TextEditorComponent {
  textEditorNgModel!: any;
  textEditorCustom!: any;
  textEditorFormControl = new FormControl();
  form!: FormGroup;
  submitted = false;
  fontStyle: string[] = ['bold', 'italic', 'underline'];
  listType: object[] = [{ 'list': 'ordered' }, { 'list': 'bullet' }];
  scriptType: object[] = [{ 'script': 'sub' }, { 'script': 'super' }];
  headerSize: object[] = [{ 'header': [1, 2, 3, 4, 5, 6, false] }];
  color: object[] = [{ 'color': [] }, { 'background': [] }];
  font: object[] = [{ 'font': [] }];
  alignType: object = [{ 'indent': '-1' }, { 'indent': '+1' }];
  attachmentType: object = ['link', 'image'];
  formula = ['formula'];

  modules = {
    formula: true,
    toolbar: [
      this.font,
      this.headerSize,
      this.fontStyle,
      this.color,
      this.listType,
      this.alignType,
      this.scriptType,
      this.attachmentType,
      this.formula
    ]
  };

  customModules = {
    formula: true,
    toolbar: [
      this.fontStyle,
      this.scriptType,
      this.listType,
      this.formula
    ]
  };
  formValue: Element | any;
  formControlData: any;
  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      textEditor: [null, Validators.required],
      textEditorWithFormID: [null, Validators.required]

    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: any) {
   if (event.currentTarget && event.target.className && event.target.className !== "ql-action" && event.target.className !== "mathquill4quill-operator-button") {
      let id: any = document.getElementById('buttonIdsave');
      const formulaDialog = document.querySelector(".ql-editing");
      if (id && (event.target.className === "ql-editor" || formulaDialog?.classList.contains('ql-hidden'))) {
        of('Observable To read formula button expand and collapse').pipe(delay(100)).subscribe(() => {
          id.focus();
        })
      }
    }
  }
  
  submitForm(event:any): void {
    this.formControlData=this.form.controls
  }
}